module.exports = __webpack_public_path__ + "roboto-v20-latin-regular.woff?60fa3c0614b8fb2f394fa29944c21540";